import 'react-multi-carousel/lib/styles.css';
import * as React from 'react';
import DontWaitBannerSection from 'components/composed/sections/DontWaitBannerSection';
import Link from 'next/link';
import { ROUTES } from '_constants/routes';
import MonitoringGraySection from 'components/composed/sections/MonitoringGraySection';
import WhatIsTrademarkMonitoringSection from 'components/composed/sections/WhatIsTrademarkMonitoringSection';
import WhyChooseMonitoringSection from '../../sections/WhyChooseMonitoringSection';
import TrademarkGeniusMonitoringSection from '../../sections/TrademarkGeniusMonitoringSection';
import MonitoringYourTrademarkSection from '../../sections/MonitoringYourTrademarkSection';

export default function TrademarkMonitoringPage() {
  return (
    <div className="monitoring">
      <div className="banner">
        <div className="copy-wrapper">
          <div className="copy">
            <h1>Trademark Monitoring</h1>
            <p>
              In today's competitive business landscape, protecting your brand
              is paramount. Your company's name, logo, and unique identifiers
              are valuable assets that require safeguarding. This is where
              Trademark Genius comes into play. We are your dedicated partner in
              ensuring that your brand remains secure and protected. Our
              specialists compile a custom monitoring search strategy to watch
              for unwanted use of your brand.
            </p>
            <div className="btn-wrapper">
              <Link href={ROUTES.trademarkMonitoringFiling}>
                <a className="orange-btn">Order My Search Report</a>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <MonitoringGraySection />
      <WhatIsTrademarkMonitoringSection />
      <WhyChooseMonitoringSection />
      <MonitoringYourTrademarkSection />
      <TrademarkGeniusMonitoringSection />

      <DontWaitBannerSection link={ROUTES.trademarkMonitoringFiling} />
    </div>
  );
}
